
<template>
  <div
    class="footer-email-collection"
  >
    <div class="footer-email-collection__content">
      <div class="footer-email-collection__inner-content">
        <div class="footer-email-collection__text">
          <p
            class="h6 footer-email-collection__title"
            :class="[schema.settings.headerColor]"
          >{{ schema.settings.title }}</p>
          <div
            class="footer-email-collection__body client-generated"
            v-html="schema.settings.body"
            :class="[schema.settings.textColor]"
          ></div>
        </div>
        <div class="footer-email-collection__form" ref="">
          <klaviyo-form
            list-id="XKQ54Z"
            message="signup"
            buttonText="signup">

          </klaviyo-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../basic/Icon.vue';
import KlaviyoForm from '../forms/KlaviyoForm.vue';

export default {
  name: 'FooterEmailCollection',
  components: {
    Icon,
    KlaviyoForm
  },
  data() {
    return {
      bvaccel: window.bvaccel
    }
  },
  props: {
    schema: Object,
    newsletter: String,
  },
};
</script>

<style lang="scss">
.footer-email-collection {
  padding: 40px 16px;

  @include tablet-up {
    padding: 0 20px;
    max-width: 210px;
  }

  @include desktop-up {
    padding: 0 20px;
    max-width: 355px;
  }

  @include mobile-only {
    padding: 10px 16px;
  }

  &__content {
    position: relative;
    display: flex;
    padding-top: 24px;
    flex-direction: column;
    align-items: center;

    @include tablet-up {
      padding: 0 0 28px;
      flex-direction: row;
      justify-content: center;
    }
    @include desktop-up {
      max-width: #{$container-max-width - 40px};
      margin: 0 auto;
      padding: 0;
    }
    @include mobile-only {
      padding-top: 10px;
    }
  }

  &__inner-content {
    width: 100%;
    max-width: 875px;
  }

  &__text {
    /* text-align: center; */
    /* margin-bottom: 68px; */

    .footer-content--center & {
      @include mobile-only {
        text-align: center;
      }
    }
  }

  &__title {
    margin-bottom: 16px;
    font-size: rem(18);
    line-height: rem(22);
    color: $color-white;

    @include tablet-up {
      margin-bottom: 12px;
    }
    @include desktop-up {
      width: 100%;
    }
  }

  &__body {
    margin-bottom: 16px;
    font-size: rem(12);
    line-height: 1.33;

    @include tablet-up {
      margin-bottom: 12px;
      font-size: rem(16);
      line-height: 1.38;
    }
    @include desktop-up {
      margin-bottom: 0;
      font-size: rem(14);
    }

    p,
    span,
    em,
    strong {
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
  }

  &__form {
    width: 100%;
    margin-bottom: 16px;


    svg {
      fill: $color-white-tea-300;
    }

    @include tablet-up {
      margin-bottom: 0;
    }
    @include desktop-up {
      margin-top: 4px;
      flex-basis: 45%;
    }

    .newsletter-form-inner-container {
      &:hover {
        cursor: pointer;

        button[type='submit'] {
          color: $color-brand-primary;
        }

        svg {
          fill: $color-white-tea-300 !important;
        }
      }
    }

    .errors {
      font-size: rem(10);
      line-height: 1.6;
      padding: 4px 0 0 0;

      ul,
      li {
        font-size: inherit;
        line-height: inherit;
      }
    }
  }

  &__image-wrapper {
    @include tablet-up {
      position: absolute;
      bottom: 0;
      left: 20px;
      width: 20%;
    }
    @include desktop-up {
      position: relative;
      bottom: auto;
      left: auto;
      width: auto;
      margin-right: 40px;
      order: 1;
      align-self: flex-end;
    }
  }

  &__image {
    display: block;
  }
}

.mce-email-input {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  max-width: 440px;
  border-width: 0px;
  padding: 12px;
  font-size: rem(16);
  line-height: rem(22);
  background-color: transparent;
  border-color: $color-white-tea-300 !important;
  color: $color-white-tea-300;
  &::placeholder {
    font-size: rem(16);
    line-height: rem(22);
    color: $color-white-tea-300;
  }
}

.mc-field-group label {
  display: none;
}

.mc-field-group {
  position: relative;
  border-bottom: 1px solid $color-white-tea-300;
}

#mc-embedded-subscribe {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
</style>
